import { render, staticRenderFns } from "./GiftCardTablePane.vue?vue&type=template&id=417748fc&scoped=true"
import script from "./GiftCardTablePane.vue?vue&type=script&lang=js"
export * from "./GiftCardTablePane.vue?vue&type=script&lang=js"
import style0 from "./GiftCardTablePane.vue?vue&type=style&index=0&id=417748fc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417748fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('417748fc')) {
      api.createRecord('417748fc', component.options)
    } else {
      api.reload('417748fc', component.options)
    }
    module.hot.accept("./GiftCardTablePane.vue?vue&type=template&id=417748fc&scoped=true", function () {
      api.rerender('417748fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GaGaCommunity/gift_card/GiftCardTablePane.vue"
export default component.exports